import PropTypes from 'prop-types';
import { userTypes } from './userTypes';

export const CUSTOM_PROP_TYPES = {
  IMAGE: PropTypes.shape({ fileSrc: PropTypes.string, fileType: PropTypes.string }),
  USER_TYPE: PropTypes.oneOf(Object.values(userTypes)),
};
